import { render, staticRenderFns } from "./ProjectFinalistComponent.vue?vue&type=template&id=23290754"
import script from "./ProjectFinalistComponent.vue?vue&type=script&lang=js"
export * from "./ProjectFinalistComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports